/* eslint-disable max-len */
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../../styles/styles.scss";
import { useTranslation } from 'react-i18next';

const TermsPage = () => { const { t: tr } = useTranslation(); return (<div className="blurred-background legal-page legal-page--terms">
    <Helmet>
      <title>{tr("public:legalText0")}</title>
    </Helmet>
    <div className="legal-page__container">
      <header className="legal-page__header">
        <span className="legal-page__eyebrow">Extra English</span>
        <h1>{tr("public:extraEnglishTermsOfService_110")}</h1>
        <p>{tr("public:legalText2")}</p>
      </header>

      <div className="legal-page__summary">
        <div>
          <span>{tr("public:legalText3")}</span>
          <strong>Alicja Marciniak</strong>
        </div>
        <div>
          <span>{tr("public:contact_39")}</span>
          <strong>szkola@extra-english.pl</strong>
        </div>
        <div>
          <span>{tr("public:legalText6")}</span>
          <strong>{tr("public:legalText7")}</strong>
        </div>
      </div>

      <article className="legal-document terms-page">
          <p>{tr("public:legalText8")}</p>

          <h2>{tr("public:legalText9")}</h2>
          <ol>
            <li>{tr("public:legalText10")}</li>
            <li>{tr("public:legalText11")}</li>
            <li>NIP: 777-255-43-86, REGON: 300953920.</li>
            <li>{tr("public:legalText13")}</li>
            <li>{tr("public:legalText14")}</li>
            <li>{tr("public:legalText15")}</li>
          </ol>

          <h2>{tr("public:legalText16")}</h2>
          <ol>
            <li>{tr("public:legalText17")}</li>
            <li>{tr("public:legalText18")}</li>
            <li>{tr("public:legalText19")}</li>
            <li>{tr("public:legalText20")}</li>
            <li>{tr("public:legalText21")}</li>
            <li>{tr("public:legalText22")}</li>
          </ol>

          <h2>{tr("public:legalText23")}</h2>
          <ol>
            <li>{tr("public:legalText24")}</li>
            <li>{tr("public:legalText25")}</li>
            <li>{tr("public:legalText26")}</li>
            <li>{tr("public:legalText27")}</li>
          </ol>

          <h2>{tr("public:legalText28")}</h2>
          <ol>
            <li>{tr("public:legalText29")}</li>
            <li>{tr("public:legalText30")}</li>
            <li>{tr("public:legalText31")}</li>
            <li>{tr("public:legalText32")}</li>
            <li>{tr("public:legalText33")}</li>
          </ol>

          <h2>{tr("public:legalText34")}</h2>
          <ol>
            <li>{tr("public:legalText35")}</li>
            <li>{tr("public:legalText36")}</li>
            <li>{tr("public:legalText37")}</li>
            <li>{tr("public:legalText38")}</li>
            <li>{tr("public:legalText39")}</li>
          </ol>

          <h2>{tr("public:legalText40")}</h2>
          <ol>
            <li>{tr("public:legalText41")}</li>
            <li>{tr("public:legalText42")}</li>
            <li>{tr("public:legalText43")}</li>
            <li>{tr("public:legalText44")}</li>
            <li>{tr("public:legalText45")}</li>
            <li>{tr("public:legalText46")}</li>
            <li>{tr("public:legalText47")}</li>
            <li>{tr("public:legalText48")}</li>
            <li>{tr("public:legalText49")}</li>
          </ol>

          <h2>{tr("public:legalText50")}</h2>
          <ol>
            <li>{tr("public:legalText51")}</li>
            <li>{tr("public:legalText52")}</li>
            <li>{tr("public:legalText53")}</li>
            <li>{tr("public:legalText54")}</li>
            <li>{tr("public:legalText55")}</li>
          </ol>

          <h2>{tr("public:legalText56")}</h2>
          <ol>
            <li>{tr("public:legalText57")}</li>
            <li>{tr("public:legalText58")}</li>
            <li>{tr("public:legalText59")}</li>
            <li>{tr("public:legalText60")}</li>
          </ol>

          <h2>{tr("public:legalText61")}</h2>
          <ol>
            <li>{tr("public:legalText62")}</li>
            <li>{tr("public:legalText63")}</li>
            <li>{tr("public:legalText64")}</li>
            <li>{tr("public:legalText65")}</li>
          </ol>

          <h2>{tr("public:legalText66")}</h2>
          <ol>
            <li>{tr("public:legalText67")}</li>
            <li>{tr("public:legalText68")}</li>
            <li>{tr("public:legalText69")}</li>
          </ol>

          <h2>{tr("public:legalText70")}</h2>
          <ol>
            <li>{tr("public:legalText71")}</li>
            <li>{tr("public:legalText72")}</li>
            <li>{tr("public:legalText73")}</li>
            <li>{tr("public:legalText74")}</li>
          </ol>

          <p className="mt-4">{tr("public:legalText75")}{" "}
            <Link to="/payment">{tr("public:paymentDetails_60")}</Link>.
          </p>
          <p>{tr("public:legalText76")}</p>
      </article>
    </div>
  </div>); };

export default TermsPage;
